module.exports = __webpack_public_path__ + "img/map_filter_comments.87e9602b.svg";